/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown> }} Audit_Details_Uno_Model_Set_DescInputs */



/**
* | output |
* | --- |
* | "The Uno assistant now runs on the model \"{model}\"." |
*
* @param {Audit_Details_Uno_Model_Set_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_uno_model_set_desc = /** @type {((inputs: Audit_Details_Uno_Model_Set_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Uno_Model_Set_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Uno-Assistent läuft jetzt mit dem Modell "${i?.model}".`)
	return /** @type {LocalizedString} */ (`The Uno assistant now runs on the model "${i?.model}".`)
});